module.exports = __webpack_public_path__ + "assets/img/eaebc33420c459c59fa01d0b6a0921fe.svg";